import { render, staticRenderFns } from "./InviteMemberModal.vue?vue&type=template&id=216fa035"
import script from "./InviteMemberModal.vue?vue&type=script&lang=js"
export * from "./InviteMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports